export default __webpack_public_path__ + "static/media/confirmRegistration.321e8a54.svg";